import React, { useState } from 'react';
import { Box, Container } from "@mui/material";
import './scheduleInspection.scss';
import Heading from '../../components/Heading';
import TicketForm from '../Tickets/components/TicketForm';

function ScheduleInspection() {
  return (
    <>
      <Heading title="Schedule Inspection" />
      <Box className="schedule-inspection-container mt-4">
        <div>
          <div className="mb-32">
            <p className="schedule-appointment-heading">Schedule Appointment</p>
            <p className="form-instruction">
              Please complete all fields to schedule an appointment for service.
            </p>
          </div>
          <TicketForm
            initialValues={{}}
            onClose={() => {}}
            isFromClient={false}
            isPopup={false}
          />
        </div>
      </Box>
    </>
  );
}

export default ScheduleInspection; 